import script from "./UserDetailsConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDetailsConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UserDetailsConfirmationDialog.vue?vue&type=style&index=0&id=35ebdc63&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ebdc63"]])

export default __exports__